import { component as defineComponent } from 'flightjs';

var contestActionsDropdown = function () {
    this.attributes({
        guaranteeLink: '[data-action-guarantee]',
        actionItem: '[data-action]',
    });

    this.after('initialize', function () {
        var $guaranteeLink = this.select('guaranteeLink');
        this.on('click', {
            actionItem: this.triggerContestAction,
            guaranteeLink: this.handleGuaranteeLink,
        });
        this.on(document, 'dataContestActionSucceeded', this.refreshContestActionElement);

        if ($('[data-contest-guarantee-modal-autostart]').length && $guaranteeLink.data('modal')) {
            $guaranteeLink.data('modal').show();
        }
    });

    this.triggerContestAction = function (event) {
        this.trigger('uiContestActionRequested', { url: $(event.target).data('action') });
    };

    this.refreshContestActionElement = function (event, data) {
        var allowedActions = data.actions;
        var contest = data.contest;

        if (!allowedActions.guaranteeprize || contest.isPrizeGuaranteed) {
            this.select('guaranteeLink').attr('data-disabled', true);
        } else {
            this.select('guaranteeLink').removeAttr('data-disabled');
        }
    };

    this.handleGuaranteeLink = function (event) {
        if (this.select('guaranteeLink').is('[data-disabled]')) {
            event.stopPropagation();
        }
    };
};

export default defineComponent(contestActionsDropdown);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/contest-actions-dropdown.js